import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-back",
  "use": "icon-back-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-back\"><path d=\"M737.2 986.1c-6.1 0-12.1-2.3-16.8-6.9L270.1 528.8c-9.3-9.3-9.3-24.3 0-33.5L720.4 44.9c9.3-9.3 24.3-9.3 33.5 0 9.3 9.3 9.3 24.3 0 33.5L320.3 512l433.6 433.6c9.3 9.3 9.3 24.3 0 33.5-4.6 4.7-10.6 7-16.7 7z\" fill=\"#333333\" p-id=\"5105\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol